<section class="position-relative">
    <swiper-container
        #swiperContainer
        class="swiperContainer"
        slides-per-view="1"
        loop="true"
        effect="fade"
    >
        <swiper-slide *ngFor="let product of products; trackBy: trackByFn">
            <div
                class="slide w-100 position-relative d-flex justify-content-center align-items-center"
                [ngStyle]="{ 'background-image': backgroundImageFor(product) }"
            >
                <div
                    class="slide__content z-1 text-white row"
                >
                    <div class="col-12 col-md-6 d-flex flex-column align-items-start">
                        <div class="mb-5 d-flex flex-column gap-2 gap-md-3">
                            <a
                                [routerLink]="linkFor(product)"
                                class="text-white text-decoration-none"
                                [attr.title]="product.title ? 'Tour ' + product.title : 'Tour'"
                                [attr.aria-label]="product.title ? 'Tour ' + product.title : 'Tour'"
                            >
                                <h3 class="slide__title fw-normal m-0">{{ product.title }}</h3>
                            </a>
                            <div class="d-flex align-items-center gap-1">
                                <span class="price__text text-uppercase">From </span>
                                <span class="fw-bold fs-4 notranslate"
                                      translate="no"
                                      lang="en">{{ product.nextDefaultPrice | currency }}</span>
                            </div>
                            <p class="slide__text m-0">{{ product.excerpt }}</p>
                        </div>

                        <app-primary-button
                            [link]="linkFor(product)"
                            [text]="'BOOK NOW'"
                            [ariaLabel]="product.title ? 'Tour ' + product.title : 'Tour'"
                        ></app-primary-button>

                        <div class="mt-3 d-flex gap-1">
                            <div class="content__tag text-uppercase bg-white text-black px-2 py-1 d-flex align-items-center gap-1">
                                <img class="content__tag__img" src="../../../../assets/svg/hour.svg" alt="Min Hours">
                                <span>
                                    {{ product.durationText }}
                                </span>
                            </div>

                            <div class="content__tag text-uppercase bg-white text-black px-2 py-1 d-flex align-items-center gap-1">
                                <img class="content__tag__img" src="../../../../assets/svg/ages.svg" alt="ages">
                                <span *ngIf="product.minAge!=0"> {{product.minAge}} +</span>
                                <span *ngIf="product.minAge==0">All Ages</span>
                            </div>

                            <div class="content__tag text-uppercase bg-white text-black px-2 py-1 d-flex align-items-center gap-1">
                                <img class="content__tag__img" src="../../../../assets/svg/bookmark.svg" alt="Bookmark">
                                <span>
                                    Nature
                                    <!-- TODO: Find product attribute -->
                                </span>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </swiper-slide>
    </swiper-container>

    <button
        (click)="onPrev()"
        class="position-absolute btn carousel__navigation-btn carousel__navigation-btn--prev"
    >
        <img
            class="navigation-btn__img"
            src="../../../../assets/icons/arrow.svg"
            alt="left-arrow"
        />
    </button>

    <button
        (click)="onNext()"
        class="position-absolute btn carousel__navigation-btn carousel__navigation-btn--next"
    >
        <img
            class="navigation-btn__img"
            src="../../../../assets/icons/arrow.svg"
            alt="rigth-arrow"
        />
    </button>
</section>
